import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from '../../../redux/connect';
import { getUploadingAttachments } from '../../../redux/selectors';
import { fetchProjectFolders, fetchFolderContents } from '../../../redux/actions';
import { filterCurrentDocument, getAllowedFiles } from '../../../utils/attachmentsHelper';
import { FilePicker } from '@adsk/bim360-matrix-react-components';
import { createGetFolderContentsMethod, createHasMoreFolderContents } from '../../../utils/docsApiHelpers';

export class PureIssueCreateFormAttachmentsSection extends PureComponent {

  constructor() {
    super(...arguments);
    this.state = {
      isSavingDocument: false,
    };
    this.handleChoosingDocument = this.handleChoosingDocument.bind(this);
    this.handleUploadFiles = this.handleUploadFiles.bind(this);
    this.getProjectFolders = this.getProjectFolders.bind(this);
    this.getFolderContents = this.getFolderContents.bind(this);
    this.hasMoreFolderContents = this.hasMoreFolderContents.bind(this);
  }

  getProjectFolders() {
    const documentsCache = {};
    // This method is called every time we load the tree from scratch. That's why we need to clean the cache here - for it to be relevant for the current tree.
    this.getFolderContentsWrapped = createGetFolderContentsMethod(documentsCache, this.props.fetchFolderContents);
    this.hasMoreFolderContentsWrapped = createHasMoreFolderContents(documentsCache);

    return new Promise((resolve, reject) => {
      this.props.fetchProjectFolders(resolve, reject);
    });
  }

  getFolderContents(urn) {
    return this.getFolderContentsWrapped(urn).then(data => filterCurrentDocument(data, this.props.targetUrn));
  }

  hasMoreFolderContents(context) {
    return this.hasMoreFolderContentsWrapped(context);
  }

  handleChoosingDocument(documentUrn, document) {
    const { chooseDocsDocument } = this.props;
    this.setState({ isSavingDocument: true }, () => {
      chooseDocsDocument(documentUrn, document);
      this.setState({ isSavingDocument: false });
    });
  }

  handleUploadFiles(files) {
    const { uploadFiles } = this.props;
    this.setState({ isSavingDocument: true }, () => {
      uploadFiles(files);
      this.setState({ isSavingDocument: false });
    });
  }

  render() {
    const { container, uploadingAttachments, canCancelFiles, onFileCancelClick, disabled } = this.props;
    const { isSavingDocument } = this.state;

    return (
      <div className="IssueCreateFormAttachmentsSection">
        <FilePicker
          container={container}
          allowUploadMultipleFiles // Allow upload multiple files.
          multi={false} // Don't allow multiple Docs documents.
          isSavingDocument={isSavingDocument}
          disabled={disabled}
          canCancelFiles={canCancelFiles}
          onFileCancelClick={onFileCancelClick}
          allowDocsDocuments
          acceptFileTypes={getAllowedFiles()}
          openDocsUrn={this.handleChoosingDocument}
          uploadFiles={this.handleUploadFiles}
          getRootFolders={this.getProjectFolders}
          getFolderContents={this.getFolderContents}
          hasMoreFolderContents={this.hasMoreFolderContents}
          files={uploadingAttachments}
        />
      </div>
    );
  }
}

PureIssueCreateFormAttachmentsSection.displayName = 'IssueCreateFormAttachmentsSection';

PureIssueCreateFormAttachmentsSection.propTypes = {
  uploadingAttachments: PropTypes.array,
  targetUrn: PropTypes.string,
  container: PropTypes.object.isRequired,
  fetchProjectFolders: PropTypes.func.isRequired,
  fetchFolderContents: PropTypes.func.isRequired,
  chooseDocsDocument: PropTypes.func.isRequired,
  uploadFiles: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
  canCancelFiles: PropTypes.bool.isRequired,
  onFileCancelClick: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  uploadingAttachments: getUploadingAttachments(state),
});


const mapDispatchToProps = {
  fetchProjectFolders,
  fetchFolderContents,
};

export default connect(mapStateToProps, mapDispatchToProps)(PureIssueCreateFormAttachmentsSection);

